module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/4A1tBkI25y6CckWkmOECkU-30459ff69468cb832656a53f1d485798.jpg";